import { APIConfig, BaseAPIConfig, buildConfig, ConfigEnvironment, ConfigMap } from "@eres/api";
import { CorrectionTak } from "./entities";

interface SSOApiConfig extends APIConfig {
	getCorrectiveTask: ( code: string ) => CorrectionTak | undefined;
	addCorrectiveTask: ( code: string, task: CorrectionTak ) => void;
}

class SSOApiConfigImpl extends BaseAPIConfig implements SSOApiConfig {
	private correctionTaskMap: { [ key: string ]: CorrectionTak } = {};

	addCorrectiveTask = ( code: string, task: CorrectionTak ) => {
		this.correctionTaskMap[ code ] = task;
	};

	getCorrectiveTask = ( code: string ) => {
		return this.correctionTaskMap[ code ];
	};
}

interface RestConfig {
	ssoAPI: () => SSOApiConfig;
	verticalAppAPI: () => SSOApiConfig;
	ndaAPI: () => SSOApiConfig;
}

const dev: RestConfig = {
	ssoAPI: () => new SSOApiConfigImpl( "https", "devgate.dubailand.gov.ae", "sso" , "stable"),
	ndaAPI: () => new SSOApiConfigImpl( "https", "devgate.dubailand.gov.ae", "sso-nda" , ""),
	verticalAppAPI: () => new SSOApiConfigImpl("https", "devgate.dubailand.gov.ae", "uaepass-auth"),
};

const qa: RestConfig = {
	ssoAPI: () => new SSOApiConfigImpl( "https", "stgapi.dubailand.gov.ae", "sso", "stable" ),
	ndaAPI: () => new SSOApiConfigImpl( "https", "stgapi2.dubailand.gov.ae", "sso-nda", "" ),
	verticalAppAPI: () => new SSOApiConfigImpl("https", "stgapi2.dubailand.gov.ae", "uaepass-auth"),
};

const prod: RestConfig = {
	ssoAPI: () => new SSOApiConfigImpl( "https", "gateway.dubailand.gov.ae", "sso", "stable" ),
	ndaAPI: () => new SSOApiConfigImpl( "https", "gateway.dubailand.gov.ae", "sso-nda", "" ),
	verticalAppAPI: () => new SSOApiConfigImpl("https", "b2c.dubailand.gov.ae", "uaepass-auth"),
};

const configs: ConfigMap<RestConfig> = {
	dev: dev,
	qa: qa,
	production: prod,
};

const cfg = buildConfig<RestConfig, ConfigEnvironment>( "dev", configs );
export default cfg;
